<template>
    <transition name="fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
        <transition name="scale">
          <div class="modal-window">
            <h3 class="modal-title">{{ title }}</h3>
  
            <div class="modal-buttons">
              <button class="confirm-btn" @click="$emit('confirm')">Да</button>
              <button class="cancel-btn" @click="close">Нет</button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </template>
  
  <script setup>
  const props = defineProps({
    visible: Boolean,
    title: {
      type: String,
      default: "Вы уверены?"
    }
  });
  
  const emit = defineEmits(["close", "confirm"]);
  
  const close = () => emit("close");
  </script>
  
  <style scoped>
  /* 🔹 Оверлей */
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  /* 🔹 Окно */
  .modal-window {
    background: white;
    padding: 32px 26px;
    border-radius: 20px;
    width: 360px;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    font-family: "Eastman-Medium";
  }
  
  .modal-title {
    font-size: 18px;
    margin-bottom: 26px;
    color: #222;
    line-height: 1.4;
  }
  
  /* 🔹 Кнопки */
  .modal-buttons {
    display: flex;
    justify-content: space-between;
    gap: 14px;
  }
  
  .confirm-btn {
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 14px;
    flex: 1;
    cursor: pointer;
  }
  
  .cancel-btn {
    background-color: #f0f0f0;
    color: #333;
    border: none;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 14px;
    flex: 1;
    cursor: pointer;
  }
  
  /* 🔹 Анимации */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  
  .scale-enter-active {
    animation: scaleIn 0.25s ease-out;
  }
  .scale-leave-active {
    animation: scaleOut 0.2s ease-in;
  }
  
  @keyframes scaleIn {
    from { transform: scale(0.9); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }
  
  @keyframes scaleOut {
    from { transform: scale(1);   opacity: 1; }
    to   { transform: scale(0.9); opacity: 0; }
  }
  
  /* 💠 Тёмная тема */
  html[data-theme="dark"] .modal-window {
    background: #2a2a2a;
    color: #eaeaea;
  }
  
  html[data-theme="dark"] .cancel-btn {
    background: #444;
    color: #ddd;
  }

  html[data-theme="dark"] .modal-window {
  background: #2a2a2a;
  color: #eaeaea;

  box-shadow:
    0 16px 50px rgba(0, 0, 0, 0.45);

  border: 1px solid rgba(255, 255, 255, 0.06);
}

html[data-theme="dark"] .modal-title {
  color: #f4f4f5;
}

html[data-theme="dark"] .cancel-btn {
  background: #444448;
  color: #f0f0f2;
}

html[data-theme="dark"] .cancel-btn:hover {
  background: #505055;
}

html[data-theme="dark"] .confirm-btn {
  background: #c94740;
  color: #ffffff;
}

html[data-theme="dark"] .confirm-btn:hover {
  background: #db5149;
}
  </style>